<template>
  <div class="row">
    <hr />
    <div class="col-md-5">
      <div class="row">
        <div class="col-md-6">
          <label :title="title" :class="{ disabled: disabled }">
            <slot></slot>
          </label>
        </div>
        <div class="col-md-6 param-modifier-col">
          <span v-if="!disabled && optional" class="optional param-modifier"> optional </span>
          <span v-if="!disabled && error" class="validation-error param-modifier">
            {{ error }} </span
          ><span v-else-if="!disabled && !optional" class="param-modifier"> required </span>
        </div>
      </div>
      <input
        type="text"
        class="text field"
        :value="data.value"
        @input="
          data.value = $event.target.value;
          emitData();
        "
        :disabled="disabled"
      />
    </div>
    <div class="col-md-7 param-description">
      <slot name="description"> </slot>
    </div>
  </div>
</template>

<script>
import { paramInputMixin } from "../mixins/paramInputMixin.js";

export default {
  name: "ParamInputText",
  mixins: [paramInputMixin],
  methods: {
    emitData: function () {
      this.$emit("change", {
        value: this.data.value || "",
        error: this.error,
        optional: this.optional,
        varName: this.varName,
        showElement: this.showElement,
        type: String,
      });
    },
  },
};
</script>
